module.exports = __webpack_public_path__ + "../resources/img/ic_refresh_p2.4256bba3.svg";